// extracted by mini-css-extract-plugin
export default {"billText":"invoice-lines_billText__zCdTK","billedForPeriod":"invoice-lines_billedForPeriod__rT9aC","startTime":"invoice-lines_startTime__zMR10"};